import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IconButtonComponent } from "src/app/shared-ui/icon-button/icon-button.component";

@Component({
  selector: 'app-contract-actions',
  standalone: true,
  imports: [IconButtonComponent],
  templateUrl: './contract-actions.component.html',
  styleUrl: './contract-actions.component.scss'
})
export class ContractActionsComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
        this.params = params;
    }

     refresh(params: ICellRendererParams): boolean {
        return false;
    }

    directToConsultaantProfile() {
      if (this.params.context?.componentParent) {
            this.params.context.componentParent.directToConsultaantProfile(this.params.data);
        }
    }

    directToTask() {
      if(this.params.context?.componentParent) {
        this.params.context.componentParent.directToTask(this.params.data);
      }
    }

    directToStakeholderList() {
      if(this.params.context?.componentParent) {
        this.params.context.componentParent.directToStakeholderList(this.params.data);
      }
    }

    openContractModal() {
      if (this.params.context?.componentParent) {
        this.params.context.componentParent.openContractModal(this.params.data);
      }
    }

}
